<script>
  export let size = 24;
  export let color = "#319ed7";
</script>

<svg
  height={size}
  viewBox="0 0 490 349"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <g filter="url(#filter0_i)">
    <path
      d="M364.66 156.546C398.576 156.546 426.07 184.112 426.07 218.116C426.07
      246.665 406.688 270.673 380.4 277.644C371.932 280.043 366.716 289.945
      366.716 301.3C366.716 314.465 375.22 325.138 385.71 325.138C387.02 325.138
      388.3 324.971 389.645 324.434C446.76 312.365 489.632 262.285 489.632
      201.43C489.632 188.085 487.738 175.169 483.918 163.093C452.015 68.2745
      362.585 0 257.25 0C233.909 0 211.348 3.35166 190.022 9.60056C189.803
      9.42228 189.198 9.10253 188.526 8.74758C187.84 8.38541 187.085 7.98661
      186.601 7.66406C176.623 -2.9229 48.8272 2.82414 41.5372 52.5175C37.9511
      60.58 38.0946 69.6308 38.2467 79.2267C38.2692 80.6412 38.2918 82.0675
      38.3027 83.5042C38.4659 105.026 47.0933 123.619 47.0933 123.619C47.0933
      123.619 46.7323 123.264 40.9948 135.109C24.5648 167.663 11.2819 213.228
      11.2819 252.134C11.2819 257.967 11.4896 263.751 11.8974 269.479C6.72105
      275.786 -6.87175 295.814 4.26954 321.317C4.26954 321.317 6.826 325.095
      6.93678 320.075C5.47676 306.74 8.59205 295.282 14.6175 292.314C17.5568
      309.84 22.3799 326.725 28.8522 342.758C28.8522 344.795 39.4539 346.449
      52.5319 346.449C65.6099 346.449 76.2116 344.795 76.2116 342.758C81.5487
      314.988 104.868 293.81 134.124 293.81C163.142 293.81 187.353 314.447
      192.723 342.352C192.723 345.818 210.75 348.63 232.987 348.63C255.225
      348.63 273.25 345.818 273.526 342.243C267.213 325.867 263.753 308.067
      263.753 289.458C263.753 274.123 266.103 259.341 270.461 245.451C270.52
      245.098 270.58 244.747 270.642 244.397L269.621 247.085C270.002 245.801
      270.409 244.529 270.843 243.27C284.315 169.75 346.783 159.084 346.783
      159.084C352.614 157.446 358.533 156.546 364.66 156.546Z"
      fill={color} />
  </g>
  <path
    d="M383.191 314.579C387.2 314.247 389.982 308.175 389.407 301.017C388.832
    293.858 385.117 288.326 381.109 288.657C377.099 288.991 374.316 295.063
    374.891 302.221C375.466 309.379 379.183 314.912 383.191 314.579Z"
    fill="black"
    fill-opacity="0.1" />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M49.2473 118.436C49.2473 118.436 83.4162 209.127 153.031 151.008C153.351
    151.008 109.921 204.656 70.6428 172.403C70.8371 172.209 63.8196 166.34
    56.4242 156.163C51.6653 149.614 46.75 141.281 43.4992 131.528L49.2473
    118.436Z"
    fill="black"
    fill-opacity="0.06" />
  <defs>
    <filter
      id="filter0_i"
      x="0"
      y="0"
      width="489.632"
      height="350.63"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha" />
      <feOffset dy="2" />
      <feGaussianBlur stdDeviation="6.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.206805 0" />
      <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
    </filter>
  </defs>
</svg>
